// extracted by mini-css-extract-plugin
export default {"container":"styles_container__EU77c","flag-image":"styles_flag-image__gIDUk"};